// extracted by mini-css-extract-plugin
module.exports = {"Error":"ErrorMessage_Error__1jNpA"};